import jQuery from 'jquery';
import 'magnific-popup';

export const initPopup = () => {
	jQuery(() => {
		const $holder = jQuery('.popup-modal');
		const $active = $holder.data('active');

		window.onload = function () {
			setTimeout(() => {
				if (!$active) {
					jQuery('a[href="#test-modal"]').trigger('click');
				}
			}, 5000);
		};

		$holder.magnificPopup({
			type: 'inline',
			preloader: false,
			focus: '#username',
			modal: true,
		});

		jQuery(document).on('click', '.popup-modal-dismiss', (e) => {
			e.preventDefault();
			jQuery.magnificPopup.close();
			const ajaxUrl = $holder.data('ajax');
			jQuery.ajax({
				url: ajaxUrl,
				data: { action: 'popup_cookies' },
				success(data) {
					// console.log(data);
				},
			});
		});
	});
};
